var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppearanceInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23.25C5.85 23.25.75 18.15.75 12S5.85.75 12 .75s11.25 4.5 11.25 10.05c0 3.6-3 6.6-6.6 6.6h-2.1c-.45 0-.9.45-.9.9 0 .3.15.45.3.6.45.45.6 1.05.6 1.65 0 1.5-1.2 2.7-2.55 2.7zM12 2.4c-5.25 0-9.6 4.35-9.6 9.6s4.35 9.6 9.6 9.6c.45 0 .9-.45.9-.9 0-.3-.15-.45-.3-.6-.45-.45-.6-1.05-.6-1.65 0-1.35 1.2-2.55 2.55-2.55h2.1c2.7 0 4.95-2.25 4.95-4.95 0-4.8-4.35-8.55-9.6-8.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85 12.707c.911 0 1.65-.74 1.65-1.65 0-.912-.739-1.65-1.65-1.65-.911 0-1.65.738-1.65 1.65 0 .91.739 1.65 1.65 1.65zM9.15 8.207c.911 0 1.65-.74 1.65-1.65 0-.912-.739-1.65-1.65-1.65-.911 0-1.65.738-1.65 1.65 0 .91.739 1.65 1.65 1.65zM14.85 8.207c.912 0 1.65-.74 1.65-1.65 0-.912-.739-1.65-1.65-1.65-.911 0-1.65.738-1.65 1.65 0 .91.739 1.65 1.65 1.65zM18.15 12.707c.911 0 1.65-.74 1.65-1.65 0-.912-.739-1.65-1.65-1.65-.911 0-1.65.738-1.65 1.65 0 .91.739 1.65 1.65 1.65z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppearanceInactive);
export default __webpack_public_path__ + "static/media/appearance_inactive.642fbdf02b08e4e77743cba89453a632.svg";
export { ForwardRef as ReactComponent };